import { Draft } from 'immer';

import { Store } from 'app/interfaces';
import { FetchProvidersResponse } from 'app/interfaces/api';

export default function setAvailableProviders(
  state: Draft<Store.State>,
  providers: FetchProvidersResponse
): void {
  state.availableProviders = providers;
}
